import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles';

export const alertMessage = (maxWidth: number) => css`
  color: ${colors.white} !important;
  max-width: ${maxWidth}px;
  line-height: 17px;
  margin-right: 10px;
  width: 100%;

  a {
    color: ${colors.white} !important;
  }
`;

export const showMoreMessage = css`
  text-decoration-line: underline;
  cursor: pointer;
  white-space: nowrap;
`;
